/* eslint-disable */
// @ts-ignore
import Keycloak from 'keycloak-js';

// Run this periodically or when initializing your app
const cleanKeycloakStorage = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('kc-') && !key.includes('id_token')) {
      localStorage.removeItem(key);
    }
  });
};

const checkStorageQuota = () => {
  try {
    const testKey = 'test-quota-' + Math.random().toString(36).substring(2);
    localStorage.setItem(testKey, new Array(1024).join('a'));
    localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

// Create a token state variable
let currentToken: string | null = null;

const getToken = (): string | null => {
  return currentToken;
  // If using persistent storage:
  // return sessionStorage.getItem('auth_token');
};

const authProvider = (keycloak: Keycloak, setToken, setUserSessionId): any => ({
  login: async () => {
    if (!checkStorageQuota()) {
      console.warn('Storage quota exceeded, clearing Keycloak data');
      cleanKeycloakStorage();
    }
    await keycloak.login({ scope: 'openid profile email' });
    return { success: true };
  },
  logout: async () => {
    localStorage.clear();
    setToken(null);
    await keycloak.logout({
      redirectUri: window.location.origin + '/',
    });
    return { success: true, redirectTo: '/' };
  },
  onError: async (error) => {
    if (error?.response?.status === 401 || error?.message?.includes('quota')) {
      setToken(null); // Clear token on error
      setUserSessionId(null);
      await keycloak.logout();
      cleanKeycloakStorage();
    }
    return error;
  },
  check: async () => {
    if (!checkStorageQuota()) {
      cleanKeycloakStorage();
    }

    try {
      // Attempt to refresh token if needed
      const refreshed = await keycloak.updateToken(5); // 5 seconds min validity

      if (refreshed) {
        setUserSessionId(
          btoa(keycloak?.tokenParsed?.sub + '||' + keycloak?.tokenParsed?.sid)
        );
        setToken(keycloak.token || null);
      }

      if (keycloak.authenticated) {
        setUserSessionId(
          btoa(keycloak?.tokenParsed?.sub + '||' + keycloak?.tokenParsed?.sid)
        );
        setToken(keycloak.token || null);

        return { authenticated: true };
      }

      return { authenticated: false };
    } catch (error) {
      console.error('Authentication check failed:', error);
      setToken(null);
      setUserSessionId(null);
      return { authenticated: false };
    }
  },
  getToken: () => getToken(), // Expose token getter
  getPermissions: async () => {
    // Implement your permission logic here
    return [];
  },
  getIdentity: async () => {
    const token = keycloak.tokenParsed;
    if (!token) return null;

    return {
      id: token.sub,
      name: token.preferred_username,
      family_name: token.family_name,
      given_name: token.given_name,
      email: token.email,
      picture: token.picture,
    };
  },
});

export default authProvider;
